import { GI18NText } from '~/presentation/common';
import { useTranslation } from 'react-i18next';
import { List, Text } from '@shopify/polaris';
import { ActionTemplate } from '../common';

interface ReplaceTemplateItemProps {
  name: string;
  onEditCampaign: () => void;
  isDetailsScreen?: boolean;
}

export const ReplaceTemplateItem = ({
  name,
  onEditCampaign,
  isDetailsScreen,
}: ReplaceTemplateItemProps) => {
  const { t } = useTranslation();

  return (
    <List.Item>
      <GI18NText
        as="span"
        variant="bodyMd"
        transformers={{
          1: (text) => (
            <Text as="span" fontWeight="semibold" variant="bodyMd">
              {text}
            </Text>
          ),
        }}
      >
        {t('Replace [1]"{{name}}"[] with other template.', { name })}
      </GI18NText>{' '}
      {!isDetailsScreen && (
        <ActionTemplate actionLabel={t('Go to edit experiment')} onHandleAction={onEditCampaign} />
      )}
    </List.Item>
  );
};
